"use client"

import { usePathname } from "next/navigation"

const titles = {
  "/app/history": "Feedback",
  "/app/feedback": "Feedback",
}

export function HeaderTitle() {
  const pathname = usePathname()

  const title = Object.entries(titles).find(([prefix]) =>
    pathname.startsWith(prefix)
  )?.[1] ?? "Practice"

  return <span className="text-sm font-medium">{title}</span>
}
